module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "250px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Serial Number"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.serialNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "serialNumber", $$v)
      },
      expression: "form.serialNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "IP Address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ipAddress", $$v)
      },
      expression: "form.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Net Mask"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.netMask),
      callback: function($$v) {
        _vm.$set(_vm.form, "netMask", $$v)
      },
      expression: "form.netMask"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mac Address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.macAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "macAddress", $$v)
      },
      expression: "form.macAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Internet Connection"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.internetConnection),
      callback: function($$v) {
        _vm.$set(_vm.form, "internetConnection", $$v)
      },
      expression: "form.internetConnection"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cloud Server Connection"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": "",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.cloudServerConnection),
      callback: function($$v) {
        _vm.$set(_vm.form, "cloudServerConnection", $$v)
      },
      expression: "form.cloudServerConnection"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e977841"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Network.vue
// module id = 1400
// module chunks = 1